<app-dialog [show]="show"
            [showHeader]="true"
            [header]="'DEA Compliant Inventory Report'"
            [subHeader]="'Select between the options below to run a report.'"
>
  <div *ngIf="show" @fadeInOut class="run-report-container">
    <form class="run-report-form" [formGroup]="runReportForm">
      <app-input formControlName="name"
                 [label]="'Report Title'"
                 [placeholder]="'Optional'"
                 (keyupEnter)="focusRadioGroup('reportType')"
                 (keydownTab)="focusRadioGroup('reportType')"
                 #reportName
      ></app-input>
      
      <app-schedules-filter *ngIf="enableC3toC5Drugs$ | async"
        class="ml-2 mr-2"
        label="Select Drug Schedules to Include"
        [control]="runReportForm.controls.schedules"
        [selectedItemsBadgeLimitCount]="5">
      </app-schedules-filter>

      <app-inventory-locations-filter *ngIf="inventoryLocationsEnabled$ | async"
        label="Location"
        [control]="runReportForm.controls.inventoryLocations">
      </app-inventory-locations-filter>

      <div class="option-list-container">
        <div class="label default">Report Type</div>

        <app-options-list
          [bordered]="false"
          [secondaryProp]="'description'"
          formControlName="reportType"
          [optionsList]="reportTypesList"
          #reportType
          (optionSelected)="focusRadioGroup('reportTime')"
        ></app-options-list>
      </div>

      <div class="option-list-container">
        <div class="label default">Audit Time</div>

        <app-options-list
          [placeholder]="'Report Time'"
          [bordered]="false"
          [secondaryProp]="'description'"
          formControlName="reportTime"
          [optionsList]="reportTimeList"
          #reportTime
        ></app-options-list>
      </div>
    </form>

    <div class="form-controls">
      <app-button [text]="'Cancel'"
                  styleClass="settings"
                  subStyle="blue"
                  customClasses="px-4"
                  [minWidth]="0"
                  (clicked)="close()"
      ></app-button>
      <app-button [text]="'Run Report'"
                  customClasses="px-4"
                  [minWidth]="0"
                  (clicked)="createReport()"
                  [disabled]="runReportForm.invalid"
                  [loading]="(isLoading$ | async) === true"
      ></app-button>
    </div>
  </div>
</app-dialog>
